import React, {useContext, useEffect, useState} from "react";
import ArchivioMarcheView from "./ArchivioMarcheView";
import {MobileContext} from "../../context/MobileContext";
import TreeContainer from "../../components/tree/TreeContainer";
import {LoaderContext} from "../../context/LoaderContext";
import {useHistory} from "react-router-dom";
import {FiltersContext} from "../../context/FiltersContext";
import {BreadcrumbsContext} from "../../context/BreadcrumbsContext";
import {getMarcheArchivioApi} from "../../services/ArchivioServices";

export default function ArchivioMarcheController({}) {

    const [marche, setMarche] = useState([]);

    const {isMobile} = useContext(MobileContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {updateFiltroArchivio} = useContext(FiltersContext);
    const {initElementiBreadcrumbs, addElementoBreadcrumbs} = useContext(BreadcrumbsContext);

    const history = useHistory();

    async function getMarche() {
        startChiamata();
        const response = await getMarcheArchivioApi();
        endChiamata();

        setMarche(response.data.data);
    }

    useEffect(() => {
        getMarche();

        /* Pulisco l'array di elementi del BreadcrumbsContext */
        initElementiBreadcrumbs('archivio', 'Archivio', `/archivio`);
    }, []);

    function goToFiat() {
        addElementoBreadcrumbs('marca', 'Fiat', `/archivio-marca/1`);
        updateFiltroArchivio('id_archivio_marca', '1');
        history.push(`/archivio-marca/1`);
    }

    function getAlberoStruttura() {
        return (
            <div className={'ns-overflow-auto ns-overflow-tree'}>
                <TreeContainer
                    data={marche}
                    idSelected={''}
                    onClickItem={(elemento) => {
                        addElementoBreadcrumbs('marca', elemento.marca, `/archivio-marca/${elemento.id_archivio_marca}`);
                        updateFiltroArchivio('id_archivio_marca', elemento.id_archivio_marca);
                        history.push(`/archivio-marca/${elemento.id_archivio_marca}`);
                    }}
                    getLabel={(elemento) => elemento.marca}
                    getFigli={(elemento) => []}
                    icona={(elemento) => {
                    }}
                />
            </div>
        );
    }

    return (
        <ArchivioMarcheView
            isMobile={isMobile}
            getAlberoStruttura={getAlberoStruttura}
            goToFiat={goToFiat}
        />
    );
}